module.exports = __webpack_public_path__ + "static/media/cases_3d_03d.3ff6f5a3.jpg";